import { User } from '@groma-dev/scaffold';
import { Rental, ShowingAvailability } from '../models';
import { AppConfig } from '../AppConfig';

export const ScaffoldClientHeaders = {
  'Content-Type': `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
  Accept: `vnd.groma.${AppConfig.Settings.Server.apiVersion}+json`,
};

// Interface for User state
export interface UserStateInterface {
  fetchingUser: boolean;
  user?: User;
}

// Interface for Rentals state
export interface RentalsStateInterface {
  fetchingRentals: boolean;
  rentals: Rental[];
  pageSize: number;
  nextPageUrl: string | null;
}

// Interface for Showing Availability state
export interface ShowingAvailabilityStateInterface {
  fetchingAvailability: boolean;
  availability: ShowingAvailability[];
}
